import React from 'react';


const ImportantText = ({ importantText }) =>  (
  <h5 className="text-error m-5">{importantText}</h5>
);

export default ImportantText;
